// const components = [
//   'Icon',
//   'Header',
//   'Footer',
//   'FirstScreen',
//   'Tabs',
//   'VideoList',
//   'VideoListItem',
//   'Banner',
//   'Section',
//   'BackTop'
// ]

import Icon from './Icon'
import Header from './Header'
import Footer from './Footer'
import FirstScreen from './FirstScreen'
import Tabs from './Tabs'
import VideoList from './VideoList'
import VideoListItem from './VideoListItem'
import Banner from './Banner'
import Section from './Section'
import BackTop from './BackTop'

const components = {
  Icon,
  Header,
  Footer,
  FirstScreen,
  Tabs,
  VideoList,
  VideoListItem,
  Banner,
  Section,
  BackTop
}

export default {
  install (Vue) {
    Object.keys(components).forEach(key => {
      Vue.component(key, components[key])
    })
    // components.forEach(name => {
    //   Vue.component(name, require('./' + name).default)
    // })
  }
}
